// Plain (wrapping) legend, not scroll — scroll pagination isn't keyboard accessible.
export const LEGEND_ICON_WIDTH_PX = 16;
export const LEGEND_ICON_TEXT_GAP_PX = 6;
export const LEGEND_ITEM_GAP_PX = 12;
export const LEGEND_AVG_CHAR_WIDTH_PX = 7;
export const DEFAULT_LEGEND_WIDTH_PX = 460;
export const LEGEND_ROW_HEIGHT_PX = 26;

export function estimateLegendRows(labels: string[], containerWidthPx: number): number {
  let rows = 1;
  let currentRowWidth = 0;

  for (const label of labels) {
    const itemWidth =
      LEGEND_ICON_WIDTH_PX + LEGEND_ICON_TEXT_GAP_PX + label.length * LEGEND_AVG_CHAR_WIDTH_PX + LEGEND_ITEM_GAP_PX;
    if (currentRowWidth > 0 && currentRowWidth + itemWidth > containerWidthPx) {
      rows++;
      currentRowWidth = itemWidth;
    } else {
      currentRowWidth += itemWidth;
    }
  }

  return rows;
}
